import React from 'react';
import { useDispatch } from 'react-redux';
import Cookies from 'universal-cookie';
import { getYear } from 'date-fns';
import { SubjectSiteFooterLink } from 'api/subjectSiteApi';
import { PUBLIC_SITE_URL } from 'appConstants';
import { GeneralAction } from 'reducers/misc';

type Props = {
  subjectCode: string;
  links: SubjectSiteFooterLink[];
};

/**
 * Cookie settings that leave out the accessibility mode's cookie
 */
const SETTINGS_WITHOUT_ACCESSIBILITY = [
  'functional',
  'functional_and_marketing',
];

const SubjectSiteFooter: React.FC<Props> = ({ subjectCode, links }) => {
  const dispatch = useDispatch();
  const cookieSettings = new Cookies().get('cookie_settings');
  const bShowAccessibility =
    !!cookieSettings &&
    !SETTINGS_WITHOUT_ACCESSIBILITY.includes(cookieSettings);

  return (
    <div className="MainFooter">
      <div className="WidthContent">
        <div className="Links">
          {/* Spaces between the items, as inline items in the subject site's markup have */}
          <ul>
            <li>
              <a
                href="https://en-gb.facebook.com/getset4education/"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
            </li>{' '}
            <li>
              <a
                href="https://twitter.com/getset4ed"
                target="_blank"
                rel="noreferrer"
              >
                Twitter
              </a>
            </li>{' '}
            {links.map((link, index) => (
              <React.Fragment key={`${index}-${link.url}`}>
                <li>
                  <a href={`${PUBLIC_SITE_URL}${link.url}`}>{link.name}</a>
                </li>{' '}
              </React.Fragment>
            ))}
            <li>
              <a
                href={`${PUBLIC_SITE_URL}/${subjectCode}/sitemap`}
                target="_blank"
                rel="noreferrer"
              >
                Site Map
              </a>
            </li>{' '}
            {/* Always rendered, as the last item's margin depends on it */}
            <li
              className={`AccessibilityLink${
                bShowAccessibility ? '' : ' Hide'
              }`}
            >
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  dispatch({ type: GeneralAction.TOGGLE_ACCESSIBILITY_MODE });
                }}
                title="Toggle accessibility mode"
              >
                Accessibility
              </a>
            </li>
          </ul>
        </div>
        <div className="Copyright">
          Copyright &copy;<span>{getYear(new Date())}</span> Get Set 4
          Education. All rights reserved.{' '}
          <span className="Develop">
            |{' '}
            <a
              href="https://www.avamae.co.uk"
              target="_blank"
              rel="noreferrer"
              title="Website Development"
            >
              Website Development
            </a>{' '}
            by AVAMAE
          </span>
        </div>
        <div className="BottomFix"></div>
      </div>
    </div>
  );
};

export default SubjectSiteFooter;
